import { ModuleTypes } from '@/components/modules/module-types.enum';

import { LinkCardListModuleDto, MarketingModuleDto } from '../dto/modules';

export function isLinkCardListModule(
  module: MarketingModuleDto
): module is LinkCardListModuleDto {
  return module.name === ModuleTypes.LinkCardList;
}
